import './MainContentAreaAll.css';
import { Link } from 'react-router-dom';
import React  ,{useState,setstate} from 'react'
function InfosysJobComponent(props){ 
    return(
       <div className="ExperienceMainLayout">   
       <br />       
        <div class="card">  
        <div class="card-footer" style={{height:"50px"}}>
             <span className="ExperienceCardFooter-Previous"><Link onClick={() => props.handlechange('DATAINC')}>Previous</Link></span>
             <span className="ExperienceCardFooter"><Link onClick={() => props.handlechange('Mphasis')}>Next</Link></span>
           </div>  

           <h5 class="card-header">
                              Infosys, pennington NJ
                              <br/>Nov-2020--MAY-2021
                              <br/>Full Stack.Net Developer
           </h5>
           <div class="card-body">
           <h3 style={{textDecoration:"underline"}}>Roles And Responsibilities</h3>
           -Works on two different website to combine common functionality for both web site and create CLP for both platform so user can login from any platform and see both account detail<br/> 
           -Work with WEB FORMS  and  SERVICES  to create Web site Common Landing Page<br/>
           -Work with XML  Data  which is retrieved from services to create CLP page for both site and created ui which display both site account information for user<br/> 
           -Created services for retrieving data from both platform and combined data together for clp<br/>
           -Use some old services and created login functionality with authentication for user and client login<br/>
           -Created web pages for financial guidance agent where user can see all financial agent for both platform<br/> 
           -Also created common database using existing database from both platform <br/>
           -Also created Stored Procedure and View And Table,CTE,FUNCTION  According Data requirement for application<br/>
           -Also work third party tool to create UI for web forms Like GE WIDGET  and use this widget in web forms for responsive ui<br/>
           -Also work on client internal web site which is developing angular and created component and ui according to given design from client and attach this ui with api<br/>  
           -Create api using .net core for new database created for common web site<br/> 
           <h3 style={{textDecoration:"underline"}}>Environment</h3>
           Microsoft Visual Studio 2013, ASP.NET, C#, XML, JSON, JavaScript, jQuery, Agile and Scrum, Team Foundation Server 2010,Bit Bucket , Git For  Windows  ,Windows Server 2008 R2/2008 2010             
           </div>            
           
       </div>
       </div>   
    )
}
export default InfosysJobComponent
